export default "__VITE_ASSET__58110933__"